import { Skeleton, TableBody, TableRow } from '@mui/material';
import React from 'react';

interface VideoCommentTableSkeletonProps {
    isLoading: boolean;
    isError: boolean;
}

const VideoCommentTableSkeleton: React.FC<
    React.PropsWithChildren<VideoCommentTableSkeletonProps>
> = (props) => {
    if (props.isLoading) {
        return (
            <TableBody>
                <TableRow>
                    <Skeleton
                        variant="rectangular"
                        width={'100%'}
                        height={48}
                    />
                </TableRow>
            </TableBody>
        );
    }
    return <>{props.children}</>;
};

export default VideoCommentTableSkeleton;
